import { render, staticRenderFns } from "./PatientResultsWalkingPathology.vue?vue&type=template&id=47c38c8a&scoped=true&"
import script from "./PatientResultsWalkingPathology.vue?vue&type=script&lang=ts&"
export * from "./PatientResultsWalkingPathology.vue?vue&type=script&lang=ts&"
import style0 from "./PatientResultsWalkingPathology.vue?vue&type=style&index=0&id=47c38c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c38c8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../common/temp/node_modules/.pnpm/vuetify-loader@1.7.3_a266eb3209234f15fc02fe57f54d2cc5/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
